<template>
  <div class="overlay">
    <div class="result-widget">
      <div class="result-widget-header">
        <button @click="onCancel()" class="btn-close">&times;</button>
      </div>
      <div class="result-widget-body">
        <template v-for="(item, index) in survey_result">
          <div
            class="survey-answer-widget"
            :key="index"
            v-if="item.section_type == 'question'"
          >
            <div class="survey-answer-header">
              <h1>{{ item.ask }}</h1>
            </div>
            <!-- For short answer -->
            <div
              v-if="item.question_type == 'short_answer'"
              class="survey-answer-body"
            >
              {{ item.answer }}
            </div>
            <!-- For long answer -->
            <div
              v-if="item.question_type == 'paragraph'"
              class="survey-answer-body"
            >
              {{ item.answer }}
            </div>
            <!-- For radio answer -->
            <div
              v-if="item.question_type == 'multiple_choice'"
              class="survey-answer-body"
            >
              <div
                class="radio-item"
                v-for="(option, option_index) in item.choice_options"
                :key="option_index"
                :class="{ active: item.answer == option.value }"
              >
                <span>{{ option.name }}</span>
              </div>
            </div>
            <!-- For checkbox answer -->
            <div
              v-if="item.question_type == 'checkboxes'"
              class="survey-answer-body"
            >
              <div
                class="checkbox-item"
                v-for="(option, option_index) in item.choice_options"
                :key="option_index"
                :class="{ active: option.value }"
              >
                <span>{{ option.name }}</span>
              </div>
            </div>
            <!-- For checkbox answer -->
            <div
              v-if="item.question_type == 'dropdown'"
              class="survey-answer-body"
            >
              <div
                class="selected-item"
                v-for="(option, option_index) in item.choice_options"
                :key="option_index"
                v-if="option.value == item.answer"
              >
                <span>{{ option.name }}</span>
              </div>
            </div>
            <!-- For file upload answer -->
            <div
              v-if="item.question_type == 'file_upload'"
              class="survey-answer-body"
            >
              <div class="uploaded-file-item">
                <img
                  v-if="$isImage(item.file_name)"
                  :src="$fullUrl('images/' + item.file_name)"
                  width="100%"
                />
                <video
                  v-if="$isVideo(item.file_name)"
                  :src="$fullUrl('images/' + item.file_name)"
                  width="100%"
                />
                <a
                  v-if="!$isVideo(item.file_name) && !$isImage(item.file_name)"
                  :download="$fullUrl('images/' + item.file_name)"
                  class="btn-download"
                  :href="$fullUrl('images/' + item.file_name)"
                  >Download file</a
                >
              </div>
            </div>
            <!-- For date answer -->
            <div v-if="item.question_type == 'date'" class="survey-answer-body">
              <div class="date-item">
                {{ item.answer | formatDate }}
              </div>
            </div>
            <!-- For date answer -->
            <div v-if="item.question_type == 'time'" class="survey-answer-body">
              <div class="date-item">
                {{ item.answer }}
              </div>
            </div>
          </div>
          <div
            class="survey-answer-widget"
            :class="{ section_widget: item.section_type == 'section' }"
            :key="index"
            v-if="item.section_type == 'section'"
            @click="selectSurvey(item)"
          >
            <h1>{{ item.title }}</h1>
            <p>{{ item.description }}</p>
          </div>
          <div
            class="survey-answer-widget"
            :class="{ title_widget: item.section_type == 'title' }"
            :key="index"
            v-if="item.section_type == 'title'"
          >
            <h2>{{ item.title }}</h2>
            <p>{{ item.description }}</p>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import { eventBus } from "@/main";
export default {
  name: "page-modal",
  props: {
    user: {
      type: [Number],
      default: () => {
        return {};
      },
    },
    type: {
      type: [String],
      default: () => {
        return "";
      },
    },
  },
  data() {
    return {
      survey_result: [],
      isLoading: false,
    };
  },
  computed: {},
  watch: {},
  mounted() {
    let vm = this;
    vm.getUserResult();
  },
  methods: {
    $isVideo(filename) {
      return /\.(webm|mp4|mkv)$/i.test(filename);
    },
    $isImage(filename) {
      return /\.(jpeg|jpe|jpg|gif|png|webp|svg)$/i.test(filename);
    },
    getUserResult() {
      let vm = this;
      vm.isLoading = true;
      vm.$store
        .dispatch("INSTRUCTOR_SCHOOL_VIEW_SURVEY_RESULT", {
          user_id: vm.user,
          type: vm.type,
        })
        .then((responce) => {
          vm.isLoading = false;
          if (responce.data.answer) {
            vm.survey_result = JSON.parse(responce.data.answer);
          } else {
            vm.survey_result = [];
            vm.$notify({
              group: "status",
              title: "Success",
              text: "Something went wrong, try again",
              type: "warn",
              duration: 3000,
            });
            vm.onCancel();
          }
        })
        .catch((error) => {
          vm.isLoading = false;
          vm.$notify({
            group: "status",
            title: "Success",
            text: "Something went wrong, try again",
            type: "warn",
            duration: 3000,
          });
        });
    },
    onCancel() {
      let vm = this;
      vm.$emit("close", null);
    },
  },
};
</script>

<style lang="scss" scoped>
$assets: "~@/assets";
.overlay {
  .result-widget {
    width: 700px;
    min-height: 400px;
    background: #fff;
    margin: 0 auto;
    border-radius: 5px;

    .result-widget-header {
      height: 40px;
      display: flex;
      justify-content: flex-end;

      .btn-close {
        font-size: 30px;
      }
    }

    .result-widget-body {
      padding: 0px 30px;

      .survey-answer-widget {
        border-bottom: 1px solid #ddd;
        margin-bottom: 20px;

        &.section_widget {
          border-bottom: 3px solid #ddd;

          h1 {
            font-size: 20px;
          }
        }

        &.title_widget {
          h2 {
            font-size: 18px;
          }

          p {
            font-size: 13px;
          }
        }

        .survey-answer-header {
          h1 {
            font-size: 16px;
            color: #000;
          }
        }

        .survey-answer-body {
          color: rgb(43, 42, 42);

          .radio-item {
            margin-bottom: 6px;

            &.active {
              color: #0884af;
              padding: 4px;
              border-left: 3px solid #0884af;
            }
          }

          .checkbox-item {
            margin-bottom: 6px;

            &.active {
              color: #0884af;
              padding: 4px;
              border-left: 3px solid #0884af;
            }
          }

          .uploaded-file-item {
            display: flex;
            flex-direction: column;
            margin-bottom: 20px;

            .btn-download {
              background: #0884af;
              color: #fff;
              padding: 11px;
              border-radius: 5px;
              text-decoration: none;
              text-align: center;
            }
          }
        }
      }
    }
  }
}
</style>